<div [innerHTML]="safeHtml" class="rich-text-content"></div>
